import { type SignInEmailSchema, signInEmailSchema } from '@coas/validators/payload';
import { zodResolver } from '@hookform/resolvers/zod';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { AuthButton } from '~/entities/AuthButton';
import { AuthInput } from '~/entities/AuthInput';
import { useSignInMutation } from '../model/mutations';

export const EmailForm = () => {
    const { mutate, isPending } = useSignInMutation();
    const { control, handleSubmit } = useForm<SignInEmailSchema>({
        resolver: zodResolver(signInEmailSchema),
        defaultValues: { provider: 'email', data: { email: '' } },
        mode: 'onTouched',
    });

    const onSubmit = useCallback((values: SignInEmailSchema) => mutate(values), [mutate]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col gap-4'>
            <AuthInput name='data.email' control={control} label='Почта' disabled={isPending} />
            <AuthButton type='submit' isLoading={isPending}>
                Войти
            </AuthButton>
        </form>
    );
};
